
import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import ScrollToTop from "@/components/ScrollToTop";

const CGV = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <section className="max-w-4xl mx-auto px-4 py-20 mt-16">
        <h1 className="text-4xl font-bold text-primary mb-8">Conditions Générales de Vente (CGV)</h1>
        <p className="text-sm text-foreground/60 mb-8">Dernière mise à jour : mai 2025</p>
        
        <div className="space-y-8">
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">1. Identité</h2>
            <p>Ce site est édité par Meredith Meneora, praticienne en hypnose thérapeutique, soins énergétiques et accompagnement intuitif. Basée à Étampes (Essonne), les prestations sont proposées en présentiel ou à distance en visio.</p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">2. Prestations proposées</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Soins énergétiques professionnels</li>
              <li>Hypnose thérapeutique</li>
              <li>Cercles de transmission et de guérison</li>
              <li>Nettoyages vibratoires de lieux</li>
            </ul>
            <p className="mt-2">Ces services s'adressent aux thérapeutes, accompagnants et praticiens du soin.</p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">3. Prise de rendez-vous</h2>
            <p>Les rendez-vous se prennent exclusivement via Calendly. Les créneaux proposés sont à jour et reflètent les disponibilités réelles. Aucun rendez-vous n'est pris par téléphone ou par e-mail.</p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">4. Modalités de paiement</h2>
            <p>Le règlement s'effectue au moment de la réservation, via Calendly. Les paiements sont sécurisés. Une séance n'est validée qu'après réception du paiement.</p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">5. Conditions d'annulation</h2>
            <p>Toute annulation ou report doit être signalé au moins 48h à l'avance. Passé ce délai, la séance est due et non remboursable. En cas d'imprévu majeur, une reprogrammation pourra être proposée selon les disponibilités.</p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">6. Responsabilité</h2>
            <p>Les accompagnements proposés ne remplacent aucun avis médical ou traitement. Ils s'inscrivent dans une démarche complémentaire de bien-être personnel et professionnel.</p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">7. Propriété intellectuelle</h2>
            <p>Tous les contenus (textes, images, supports transmis) sont la propriété de Meredith Meneora. Toute reproduction, diffusion ou réutilisation sans accord préalable est interdite.</p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">8. Données personnelles</h2>
            <p>Les données collectées sont confidentielles. Elles ne sont jamais cédées ni revendues. Elles servent uniquement à assurer le bon déroulement de l'accompagnement.</p>
          </div>
          
          <div>
            <h2 className="text-2xl font-semibold text-primary mb-3">9. Contact</h2>
            <p>📱 06 07 50 74 12 Uniquement via WhatsApp ➡️ <a href="https://wa.me/33607507412" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Écrire sur WhatsApp</a></p>
          </div>
        </div>
        
        <div className="mt-12 text-center">
          <Link to="/">
            <Button variant="outline">← Retour à l'accueil</Button>
          </Link>
        </div>
      </section>
      
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default CGV;
